import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllUserTestResult,
  getPerformanceTestResult,
} from "../../redux/performance/actions";
import { useNavigate, useParams } from "react-router-dom";

const useLeaderboard = ({ data }) => {
  const [state, setState] = useState({
    view: false,
    averageGrade: "",
    rank: 0,
  });
  const user = useSelector((state) => state.auth.user.data);
  const testResult = useSelector((state) => state.performance.performance.data);
  const loader = useSelector(
    (state) => state.performance.allTestResult.loading
  );
  const allTestResult = useSelector(
    (state) => state.performance.allTestResult.data
  );
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const viewHandler = () => {
    setState((state) => ({ ...state, view: true }));
  };

  useEffect(() => {
    if (data?.objectId) {
      const payload = {
        testPtr: data.objectId,
        customerPtr: user.objectId,
      };
      dispatch(getPerformanceTestResult(payload));
      dispatch(getAllUserTestResult(payload));
    }
  }, [data?.objectId]);

  useEffect(() => {
    if (allTestResult?.length > 1) {
      const sumPer = allTestResult.reduce(
        (sum, obj) => sum + obj?.Percentage,
        0
      );
      const averageGrade = sumPer / allTestResult?.length;
      const avGrade = averageGrade.toFixed(2);
      let grade = "";
      if (avGrade >= 90 && avGrade <= 100) {
        grade = "A";
      } else if (avGrade >= 85 && avGrade < 90) {
        grade = "B";
      } else if (avGrade >= 83 && avGrade < 85) {
        grade = "C";
      } else if (avGrade >= 79 && avGrade < 83) {
        grade = "D";
      } else if (avGrade >= 31 && avGrade < 79) {
        grade = "E";
      } else if (avGrade < 31) {
        grade = "F";
      }
      const index = allTestResult?.findIndex(
        (obj) => obj?.customerPtr?.objectId === user?.objectId
      );

      setState((state) => ({
        ...state,
        averageGrade: grade,
        rank: index ? index + 1 : 1,
      }));
    } else {
      setState((state) => ({
        ...state,
        averageGrade: testResult?.YourGrade,
        rank: 1,
      }));
    }
  }, [allTestResult, testResult]);

  const showFirstLastDigits = (mobileNumber) => {
    if (mobileNumber?.length >= 4) {
      let firstTwo = mobileNumber.substring(0, 2);
      let lastTwo = mobileNumber.substring(mobileNumber.length - 2);

      return `${firstTwo}XXXXXX${lastTwo}`;
    } else {
      return " ";
    }
  };

  const viewSolutionHandler = () => {
    setState((state) => ({ ...state, view: false }));
    navigate(`/view-solution/${id}/${data.objectId}`);
  };

  return {
    state,
    testResult,
    allTestResult,
    loader,
    showFirstLastDigits,
    viewHandler,
    viewSolutionHandler,
  };
};

export default useLeaderboard;
